import { useEffect, useState } from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import Select from "react-select";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";
import { useNavigate, useSearchParams } from "react-router-dom";
import CreatePackage from "./createPackage";
import AddDealershipModal from "./AddDealershipModal";
// import { getISOWeek } from "date-fns/getISOWeek";
import CreateFormModal from "./createFormModal";
import { getWeekOfYear } from "./constants/utils";
import { internalUsers } from "./constants/userTypes";

const CreatePrivateEvent = ({
  dealerships,
  setDealerTrigger,
  setIsLoading,
  isDarkMode,
  editMode = false,
  setDisplayComponent,
  users,
}) => {
  const [isOpenAll, setIsOpenAll] = useState(false);
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [eventData, seteventData] = useState(null);
  const [parentForms, setParentForms] = useState([]);
  const [parentForms2, setParentForms2] = useState([]);
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userType");
  const { language } = useLanguage();
  const pageTranslations = translations["forms"];
  const [brands, setBrands] = useState();
  const [packages, setallPackages] = useState();
  const [eventId, setEventId] = useState(null);
  const [confirmDeleteEvent, setConfirmDeleteEvent] = useState(false);
  const [isDeletingEvent, setIsDeletingEvent] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedDealership, setSelectedDealership] = useState(null);
  const [foundRep, setfoundRep] = useState(false);
  const [foundBrand, setfoundBrand] = useState(false);
  const [parentId, setParentId] = useState("");
  const [childId, setChildId] = useState("");
  const [listIds, setListIds] = useState([]);
  const [configIds, setConfigIds] = useState([]);
  const [formDealerID, setformDealerID] = useState("");
const [openSection, setOpenSection] = useState("");
   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
 const isAdminUser =
    role &&
    internalUsers.includes(role) &&
    ["Admin", "Super Admin"].includes(userData?.roles?.[0]?.name);
  const canDeleteEvent =
    editMode &&
    isAdminUser &&
    userData?.roles?.[0]?.permissions?.some(
      (permission) => permission.name === "Private Event Destroy"
    );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  const isRepresentative = role === "Representative";
  
  // useEffect(() => {
  //   // Save the current viewport meta
  //   const meta = document.querySelector('meta[name="viewport"]');
  //   const originalContent = meta?.getAttribute("content");

  //   // Change viewport for this component
  //   if (meta) {
  //     meta.setAttribute("content", "width=device-width, initial-scale=1.0");
  //   }

  //   return () => {
  //     // Restore original viewport when component unmounts
  //     if (meta && originalContent) {
  //       meta.setAttribute("content", originalContent);
  //     }
  //   };
  // }, []);
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;
  
    const originalContent = meta.getAttribute("content");
    let currentContent = originalContent;
  
    const updateViewport = () => {
      const screenWidth = window.screen.width;
      const isMobile = screenWidth < 768;
  
      const newContent = isMobile
        ? "width=device-width, initial-scale=1.0"
        : "width=1000";
  
      // Only update if it’s different from current
      if (currentContent !== newContent) {
        meta.setAttribute("content", newContent);
        currentContent = newContent;
      }
    };
  
    // Initial update
    updateViewport();
  
    // Update on window resize
    window.addEventListener("resize", updateViewport);
  
    // Cleanup on unmount
    return () => {
      if (originalContent) {
        meta.setAttribute("content", originalContent);
      }
      window.removeEventListener("resize", updateViewport);
    };
  }, []);
  const managerOptions =
    users &&
    users.projectMangers.length > 0 &&
    users.projectMangers.map((user) => ({
      value: user.id,
      label: user.name,
    }));
  const repOptions =
    users &&
    users.representatives.length > 0 &&
    users.representatives.map((user) => ({
      value: user.id,
      label: user.name,
    }));
  const animatorOptions =
    users?.animaters?.length > 0
      ? [
          {
            label: translations.dropdown.animatorOptions.op1[language],
            value: "1.1",
          },
          {
            label: translations.dropdown.animatorOptions.op2[language],
            value: "1.2",
          },
          ...users.animaters.map((user) => ({
            value: user.id,
            label: user.name,
          })),
        ]
      : [];

  const agentOptions =
    users &&
    users.agents.length > 0 &&
    users.agents.map((user) => ({
      value: user.id,
      label: user.name,
    }));

  const commonDropdown = [
    { label: translations["dropdown"].yes[language], value: "Yes" },
    { label: translations["dropdown"].no[language], value: "No" },
  ];
  const fidgiContestOptions = [
    ...commonDropdown,
    {
      label: translations["dropdown"].toBeConfirmed[language],
      value: "To be confirmed",
    },
  ];

  const handleToggleAll = () => {
    setIsOpenAll((prevIsOpenAll) => !prevIsOpenAll);
  };
  useEffect(() => {
    // Get the current URL
    var currentUrl = window.location.href;
    // Check if '=' is found and extract the text after it
    const equalsIndex = currentUrl.indexOf("=");
    if (equalsIndex !== -1) {
      const secondEqualsIndex = currentUrl.indexOf("=", equalsIndex + 1);

      if (secondEqualsIndex !== -1) {
        const lastParameterValue = currentUrl.substring(secondEqualsIndex + 1);
        setEventId(lastParameterValue);
      }
    }
  });
  const initialData = {
    list_id: editMode && eventData ? eventData.list_id : "",
    list_name: editMode && eventData ? eventData.list_name : "",
    config_id: editMode && eventData ? eventData.config_id : "",
    config_name: editMode && eventData ? eventData.config_name : "",
    nom_vp: editMode && eventData ? eventData.nom_vp : "",
    week: editMode && eventData ? eventData.week : "",
    start_date: editMode && eventData ? eventData.start_date : "",
    end_date: editMode && eventData ? eventData.end_date : "",
    dealership_id: editMode && eventData ? eventData.dealership_id : "",
    project_manager_id:
      editMode && eventData ? eventData.project_manager_id : "",
    sales_rep_id: editMode && eventData ? eventData.sales_rep_id : "",
    animator_id: editMode && eventData ? eventData.animator_id : "",
    package_id: editMode && eventData ? eventData.package_id : "",
    comments: editMode && eventData ? eventData.comments : "",
    mailing: editMode && eventData ? eventData.mailing : "",
    web: editMode && eventData ? eventData.web : "",
    banner: editMode && eventData ? eventData.banner : "",
    news_letter: editMode && eventData ? eventData.news_letter : "",
    facebook: editMode && eventData ? eventData.facebook : "",
    ad_words: editMode && eventData ? eventData.ad_words : "",
    sms: editMode && eventData ? eventData.sms : "",
    fidgi_contest: editMode && eventData ? eventData.fidgi_contest : "",
    clients: editMode && eventData ? eventData.clients : "",
    inactive: editMode && eventData ? eventData.inactive : "",
    conquest: editMode && eventData ? eventData.conquest : "",
    massif: editMode && eventData ? eventData.massif : "",
    amount: editMode && eventData ? eventData.amount : "",
    confirmation_agent_id:
      editMode && eventData ? eventData.confirmation_agent_id : "",
    no_show_agent_id: editMode && eventData ? eventData.no_show_agent_id : "",
    call_campaign: editMode && eventData ? eventData.call_campaign : "regular",
    call_centre: editMode && eventData ? eventData?.call_centre : "",

    carton: editMode && eventData ? eventData.carton : "",
    brand_id: editMode && eventData ? eventData.brand_id : "",
    invoice: editMode && eventData ? eventData.invoice : "",
    amount_animator: editMode && eventData ? eventData.amount_animator : "",
    invoice_animator: editMode && eventData ? eventData.invoice_animator : "",
    commission_paid: editMode && eventData ? eventData.commission_paid : "",
    instructions: editMode && eventData ? eventData.instructions : "",
    mailing_amount: editMode && eventData ? eventData.mailing_amount : "",
    status: editMode && eventData ? eventData.status : "",
  };

  const validationSchema = Yup.object().shape({
    nom_vp: Yup.string().required(
      pageTranslations.validationTranslations.nom_vp[language]
    ),
    start_date: Yup.date().required(
      pageTranslations.validationTranslations.start_date[language]
    ),
    end_date: Yup.date().required(
      pageTranslations.validationTranslations.end_date[language]
    ),
    dealership_id: Yup.number().required(
      translations.quickCreationModal.validationsText.dealershipText[language]
    ),
    project_manager_id: Yup.number().required(
      pageTranslations.validationTranslations.manager[language]
    ),
    sales_rep_id: Yup.number().required(
      pageTranslations.validationTranslations.sales_representative[language]
    ),
    animator_id: Yup.number().required(
      pageTranslations.validationTranslations.animator[language]
    ),
    package_id: Yup.number().required(
      pageTranslations.validationTranslations.package[language]
    ),
    comments: Yup.string().required(
      pageTranslations.validationTranslations.comments[language]
    ),
    mailing: Yup.string().required(
      pageTranslations.validationTranslations.mailing[language]
    ),
    web: Yup.string().required(
      pageTranslations.validationTranslations.web[language]
    ),
    banner: Yup.string().required(
      pageTranslations.validationTranslations.banner[language]
    ),
    news_letter: Yup.string().required(
      pageTranslations.validationTranslations.newsletter[language]
    ),
    facebook: Yup.string().required(
      pageTranslations.validationTranslations.facebook[language]
    ),
    ad_words: Yup.string().required(
      pageTranslations.validationTranslations.adwords[language]
    ),
    sms: Yup.string().required(
      pageTranslations.validationTranslations.sms[language]
    ),
    fidgi_contest: Yup.string().required(
      pageTranslations.validationTranslations.fidgi_contest[language]
    ),
    clients: Yup.string().required(
      pageTranslations.validationTranslations.clients[language]
    ),
    inactive: Yup.string().required(
      pageTranslations.validationTranslations.inactive[language]
    ),
    conquest: Yup.string().required(
      pageTranslations.validationTranslations.conquest[language]
    ),
    massif: Yup.string().required(
      pageTranslations.validationTranslations.massif[language]
    ),
    amount: Yup.string().required(
      pageTranslations.validationTranslations.amount[language]
    ),
    confirmation_agent_id: Yup.string().required(
      pageTranslations.validationTranslations.confirmAgent[language]
    ),
    no_show_agent_id: Yup.string().required(
      pageTranslations.validationTranslations.noShowAgent[language]
    ),
    carton: Yup.string().required(
      pageTranslations.validationTranslations.carton[language]
    ),
    brand_id: Yup.string().required(
      translations.quickCreationModal.validationsText.brandText[language]
    ),
    invoice: Yup.string().required(
      pageTranslations.validationTranslations.invoice[language]
    ),
    amount_animator: Yup.string().required(
      pageTranslations.validationTranslations.amountAnimator[language]
    ),
    invoice_animator: Yup.string().required(
      pageTranslations.validationTranslations.invoiceAnimator[language]
    ),
    commission_paid: Yup.string().required(
      pageTranslations.validationTranslations.commissionPaid[language]
    ),
    instructions: Yup.string().required(
      pageTranslations.validationTranslations.instructions[language]
    ),
    mailing_amount: Yup.string().required(
      pageTranslations.validationTranslations.mailing_amount[language]
    ),
    status: Yup.string().required(
      pageTranslations.validationTranslations.status[language]
    ),
  });

  const validateAmount = (value) => {
    if (value === undefined || value === null || String(value).trim() === "") {
      return undefined;
    }

    return /^\d+(\.\d+)?$/.test(String(value).trim())
      ? undefined
      : pageTranslations.validationTranslations.amountNumeric[language];
  };

  const handleValidatedSubmit = async (event, validateForm, submitForm) => {
    event.preventDefault();

    const errors = await validateForm();
    const firstError = Object.values(errors)[0];

    if (firstError) {
      toast.error(firstError);
      return;
    }

    submitForm();
  };

  const handleSubmit = async (values, { resetForm }, error) => {
    setIsLoading(true);
    try {
      const url = `${ApiUrl}/api/user/private-events${
        editMode ? `/${eventId}` : ""
      }`;
      const method = editMode ? "PUT" : "POST";
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...values,
          dealership_id: selectedDealership,
          package_id: selectedPackage,
        }),
      });
      // console.log("res", res)
      const data = await res.json();
      // console.log("data", data)
      if (data.status === "success") {
        toast.success(data.message);
        navigate("/event-portal");
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  const options = dealerships.map((dealership) => ({
    value: dealership.id,
    label: dealership.name,
  }));
  const brandOptions =
    brands &&
    brands.length > 0 &&
    brands.map((brand) => ({
      value: brand.id,
      label: brand.name,
    }));
  const statusOptions = [
    {
      label: translations.usersPage.createUser.statusOptions.active[language],
      value: "Active",
    },
    {
      label:
        translations.usersPage.createUser.statusOptions.cancelled[language],
      value: "Cancelled",
    },
    {
      label: translations.usersPage.createUser.statusOptions.waiting[language],
      value: "Waiting",
    },
    {
      label:
        translations.usersPage.createUser.statusOptions.completed[language],
      value: "Completed",
    },
    {
       label:
       translations.usersPage.createUser.statusOptions.pending[language],
       value: "Pending",
     },
  ];

  useEffect(() => {
    const getBrands = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(ApiUrl + "/api/user/get-brands", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          setBrands(data.list_of_brands);
        } else {
          toast.error(data.message);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching dealerships:", error);
        // Handle error or show a toast if needed
      }
    };
    const getPackagess = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/package-index/allPackage", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          const packageOptions =
            data.packages &&
            data.packages.length > 0 &&
            data.packages.map((item) => ({
              value: item.id,
              label: item.name,
            }));
          setallPackages(packageOptions);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching dealerships:", error);
        // Handle error or show a toast if needed
      }
    };

    getBrands();
    getPackagess();
    // getListIds();
  }, [token]);

  const getListIds = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/list-ids", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status === "success") {
        const lists =
          data.list_ids.lists &&
          data.list_ids.lists.length > 0 &&
          data.list_ids.lists.map((list) => {
            return { label: list.list_name, value: list.list_id };
          });
        const configss =
          data.config_ids.lists &&
          data.config_ids.lists.length > 0 &&
          data.config_ids.lists.map((list) => {
            return {
              label: list.calendar_config_name,
              value: list.calendar_config_id,
            };
          });

        setListIds(lists);
        setConfigIds(configss);
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };

  // useEffect(() => {
  //   document.getElementById("dateBtn").click();
  // }, []);

  useEffect(() => {
    const getEventData = async () => {
      // setIsLoading(true);
      try {
        const res = await fetch(
          ApiUrl + "/api/user/private-events/" + eventId,

          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();
        if (data.status === "success") {
          seteventData(data?.privateEvent);
          setParentForms(data?.parentForm);
          setSelectedPackage(data?.privateEvent.package_id);
          setSelectedDealership(data?.privateEvent.dealership_id);
          setformDealerID(data?.privateEvent.dealership_id);
          // setfoundRep
        } else {
          toast.error(data.message);
        }
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
      }
    };
    if (eventId) {
      getEventData(eventId);
    }
  }, [eventId]);

  const createEvent = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/create-event", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ event_id: eventId }),
      });
      const data = await res.json();
      if (data.status === "success") {
        setDisplayComponent("edit-form");
        window.history.pushState(
          { id: "gallery", randomData: window.Math.random() },
          "title",
          "/event-portal?page=edit-form&event_id=" +
            eventId +
            "&form_id=" +
            data.event_url
        );
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };

  const getRep = async (dealerId, values, setValues) => {
    setIsLoading(true);

    try {
      const res = await fetch(
        ApiUrl + "/api/user/select-dealership/" + dealerId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          // body: JSON.stringify({ event_id: eventId }),
        }
      );
      const data = await res.json();
      if (data.status === "success") {
        setfoundRep(data.representative !== null ? true : false);
        setfoundBrand(data.brand !== null ? true : false);
        setValues({
          ...values,
          dealership_id: dealerId,
          sales_rep_id:
            data.representative !== null ? data.representative.id : "",
          brand_id: data.brand !== null ? data.brand.id : "",
        });
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };

  const checkParent = async (event_Id) => {
    setIsLoading(true);
    try {
      const res = await fetch(
        ApiUrl + "/api/user/check-parentform/" + event_Id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (data.status === "success") {
        // const options =
        //   data?.parentForm &&
        //   data?.parentForm.length > 0 &&
        //   data.parentForm.map((item) => {
        //     return { label: item?.indexed_date, value: item.id };
        //   });
        if (data?.parentForm && data?.parentForm.length > 0) {
          const options =
            data?.parentForm &&
            data?.parentForm.length > 0 &&
            data.parentForm.map((item) => {
              return { label: item?.indexed_date, value: item.id };
            });
          setParentForms2(options);
        }
        if (data?.clientForm && data?.clientForm.length > 0) {
          const options =
            data?.clientForm &&
            data?.clientForm.length > 0 &&
            data.clientForm.map((item) => {
              // return { label: item?.indexed_date, value: item.id };
              return { label: item?.indexed_date, value: item?.parent_id ? item?.parent_id : item?.child_id , parent_form: item?.parent_id ? true : false, };

            });
          setParentForms2(options);
        }
        // setParentForms2(options);

        setEventId(event_Id);
        // setParentId(data?.parentForm);
        var createModal = new window.bootstrap.Modal(
          document.getElementById("createForm")
        );
        createModal.show();
      } else {
        // toast.error(data.message);
        setDisplayComponent("create-event");

        window.history.pushState(
          {
            id: "gallery",
            randomData: window.Math.random(),
          },
          "title",
          "/event-portal?page=create-event&parent_id=" +
            event_Id +
            "&event-navigate=true"
        );
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };

  const changeStatus = async (status, event_Id) => {
    setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/change-status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status: status, id: event_Id }),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };

  const handleDeleteEvent = async () => {
    if (!canDeleteEvent || !eventData?.id || isDeletingEvent) return;

    setIsDeletingEvent(true);
    try {
      const res = await fetch(
        `${ApiUrl}/api/user/private-event-destroy/${eventData.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (!res.ok || data.status !== "success") {
        toast.error(data.message || translations.alertMessages.wentWrong[language]);
        return;
      }

      toast.success(translations.alertMessages.eventDeletion[language]);
      window.location.replace("/event-portal?page=events");
    } catch (error) {
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setIsDeletingEvent(false);
    }
  };

  const renderDeleteEventControls = () => {
    if (!canDeleteEvent || !eventData?.id) return null;

    return confirmDeleteEvent ? (
      <div className="d-inline-flex align-items-center gap-2 flex-wrap mx-2">
        <button
          type="button"
          className="btn btn-success"
          disabled={isDeletingEvent}
          onClick={handleDeleteEvent}
        >
          {translations.commonFields.confirm[language]}
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          disabled={isDeletingEvent}
          onClick={() => setConfirmDeleteEvent(false)}
        >
          {translations.commonFields.cancel[language]}
        </button>
      </div>
    ) : (
      <button
        type="button"
        className="btn btn-danger mx-2"
        onClick={() => setConfirmDeleteEvent(true)}
      >
        <i className="bi bi-trash"></i>{" "}
        {translations.commonFields.deleteEvent[language]}
      </button>
    );
  };

  const handleCopy = async (isParentForm) => {
    try {
      setIsLoading(true);
      const res = await fetch(ApiUrl + "/api/user/copy-parentform?page=", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          // parent_id: parentId,
          // child_id: childId,
          event_id: eventId,
          [!isParentForm ? "child_id" : "parent_id"]: parentId,
          drive_dealership_id: formDealerID || ""
          // week: week,
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        setDisplayComponent("edit-form");
        window.history.pushState(
          {
            id: "gallery",
            randomData: window.Math.random(),
          },
          "title",
          `/event-portal?page=edit-form&event_id=${eventId}&form_id=${data.event_url}`
        );
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  return (
    <div className="create-event">
      <div class="container maincont">
        <div id="app" className="appcountainer2">
          <AddDealershipModal
            setDealerTrigger={setDealerTrigger}
            setIsLoading={setIsLoading}
            setSelectedDealership={setSelectedDealership}
            dealerships={dealerships}
            users={users}
            quickAdd={false}
          />
          <CreatePackage
            setDealerTrigger={setDealerTrigger}
            setIsLoading={setIsLoading}
            isDarkMode={isDarkMode}
            setSelectedPackage={setSelectedPackage}
            packages={packages}
            setallPackages={setallPackages}
          />
          <CreateFormModal
            isDarkMode={isDarkMode}
            handleCopy={handleCopy}
            parentId={parentId}
            setParentId={setParentId}
            eventId={eventId}
            setEventId={setEventId}
            setDisplayComponent={setDisplayComponent}
            parentForms={parentForms2}
            setChildId={setChildId}
            formDealerID={formDealerID}
          />
          <Formik
            initialValues={initialData}
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ values, setValues, setFieldValue, validateForm, submitForm }) => (
              <Form
                onSubmit={(event) =>
                  handleValidatedSubmit(event, validateForm, submitForm)
                }
              >

                <div class="edit-form-form">
                  <div class="headersec">
                    <nav class="navbar navbar-expand-md navbar-light">
                      <div class="d-flex justify-content-between w-100 edit-event-header-mobile">
                        <div className="edit-event-header-mobile-wraper-2">
                          {isMobile && (
                            <button
                              type="button"
                              className="back-button"
                              onClick={() => navigate(-1)}
                              // style={{ marginTop: !editMode ? "0px" : "6px" }}
                            >
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          )}

                          <h2
                            className={`${
                              isDarkMode ? "darkthead" : ""
                            }edit-event-header-mobile-title`}
                          >
                            {editMode
                              ? eventData?.nom_vp +
                                "  (" +
                                eventData?.week +
                                ")"
                              : pageTranslations.title[language]}
                          </h2>
                        </div>
                        <div
                          className="d-flex gap-2"
                          style={{ marginRight: "16px" }}
                        >
                          {false && (
                            <button
                              type="button"
                              className="admin-btn btn btn-primary"
                              onClick={() => {
                                setDisplayComponent("view-billing-report");

                                window.history.pushState(
                                  {
                                    id: "gallery",
                                    randomData: window.Math.random(),
                                  },
                                  "title",
                                  "/event-portal?page=view-billing-report&event_id=35"
                                );
                              }}
                            >
                              <i className="bi bi-file-earmark-bar-graph"></i>{" "}
                              {
                                translations.EventsPortal.eventsTableButtons
                                  .vieBillingReport[language]
                              }
                            </button>
                          )}
                        </div>
                        {false && (
                          <>
                            <button
                              class="navbar-toggler"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#navbarNav"
                              aria-controls="navbarNav"
                              aria-expanded="false"
                              aria-label="Toggle navigation"
                            >
                              <span class="navbar-toggler-icon"></span>
                            </button>
                            <div
                              class="collapse navbar-collapse justify-content-end"
                              id="navbarNav"
                            >
                              <ul class="navbar-nav">
                                <li class="nav-item">
                                  <button
                                    id="dateBtn"
                                    class="admin-btn btn-primary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    href="#multiCollapseDate"
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="multiCollapseDate"
                                  >
                                    <i class="bi bi-calendar"></i>{" "}
                                    {pageTranslations.datesBtn[language]}
                                  </button>
                                </li>
                                <li class="nav-item">
                                  <button
                                    class="admin-btn btn-primary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#multiCollapseOptions"
                                    aria-expanded="false"
                                    aria-controls="multiCollapseOptions"
                                  >
                                    <i class="bi bi-people-fill"></i>{" "}
                                    {pageTranslations.conquestBtn[language]}
                                  </button>
                                </li>
                                <li class="nav-item">
                                  <button
                                    class="admin-btn btn-primary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#multiCollapseInfosvente"
                                    aria-expanded="false"
                                    aria-controls="multiCollapseInfosvente"
                                  >
                                    <i class="bi bi-info-circle"></i>{" "}
                                    {pageTranslations.salesInfoBtn[language]}
                                  </button>
                                </li>
                                <li class="nav-item">
                                  <button
                                    class="admin-btn btn-primary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#multiCollapseInfoscontact"
                                    aria-expanded="false"
                                    aria-controls="multiCollapseInfoscontact"
                                  >
                                    <i class="bi bi-person-lines-fill"></i>{" "}
                                    {pageTranslations.contactBtn[language]}
                                  </button>
                                </li>
                                <li class="nav-item">
                                  <button
                                    class="admin-btn btn-primary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#multiCollapseInfosequipe"
                                    aria-expanded="false"
                                    aria-controls="multiCollapseInfosequipe"
                                  >
                                    <i class="bi bi-person-badge"></i>{" "}
                                    {pageTranslations.teamBtn[language]}
                                  </button>
                                </li>
                                <li class="nav-item">
                                  <button
                                    class="admin-btn btn-primary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#multiCollapseInfospromos"
                                    aria-expanded="false"
                                    aria-controls="multiCollapseInfospromos"
                                  >
                                    <i class="bi bi-stars"></i>{" "}
                                    {pageTranslations.promosBtn[language]}
                                  </button>
                                </li>
                                <li class="nav-item">
                                  <button
                                    className="admin-btn btn-primary"
                                    type="button"
                                    onClick={handleToggleAll}
                                  >
                                    <i className="bi bi-folder2-open"></i>{" "}
                                    {isOpenAll
                                      ? pageTranslations.closeAllBtn[language]
                                      : pageTranslations.openAllBtn[language]}
                                  </button>
                                  {/* <button class="admin-btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target=".multi-collapse" aria-expanded="false" aria-controls="multiCollapseDate multiCollapseOptions multiCollapseInfosvente multiCollapseInfoscontact multiCollapseInfosequipe multiCollapseInfospromos"><i class="bi bi-folder2-open"></i> Open All</button> */}
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                        {editMode && (
                          // <div className="mx-2">
                          //   <h3 id={ eventData?.status === "Active" ||
                          //                     eventData?.status === "Completed" ? "activeStatus" :eventData?.status === "Waiting"
                          //                     ? "waitingStatus"
                          //                     : "cancelStatus" } >
                          //     {eventData?.status}
                          //   </h3>
                          // </div>
                          <div className="d-flex align-items-center mx-2 col-2 drop-down-status-mobile">
                            <Field
                              name="status"
                              render={({ field, form }) => (
                                <>
                                  <div
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      backgroundColor:
                                        field.value === "Active" ||
                                        field.value === "Completed"
                                          ? "#34DBB4"
                                          : field.value === "Waiting"
                                          ? "orange"
                                          : "red",
                                      borderRadius: "50%",
                                      marginRight: "8px", // Adjust the spacing between the circle and the dropdown
                                    }}
                                  ></div>
                                  <Select
                                    className="selectpicker w-100 status-dropdown-mobile"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    // name="status"
                                    isDisabled={
                                      userData &&
                                      !userData.roles[0].permissions.some(
                                        (item) =>
                                          item.name === "Change Event Status"
                                      ) || isRepresentative
                                    }
                                    // options={statusOptions}
                                    options={statusOptions.map((opt) => ({
                                      ...opt,
                                      isDisabled: opt.value.toLocaleLowerCase() === "pending" &&  !isAdminUser
                                    }))}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isSearchable={false}
                                    value={
                                      (statusOptions &&
                                        statusOptions.length > 0 &&
                                        statusOptions.find(
                                          (option) =>
                                            option.value === field.value
                                        )) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) => {
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      );

                                      changeStatus(
                                        selectedOption.value,
                                        eventData.id
                                      );
                                    }}
                                    // maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        width: "100%",
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? userData &&
                                            userData.roles[0].permissions.some(
                                              (item) =>
                                                item.name ===
                                                "Change Event Status"
                                            )
                                            ? "transparent"
                                            : "#ced4da66"
                                          : userData &&
                                            userData.roles[0].permissions.some(
                                              (item) =>
                                                item.name ===
                                                "Change Event Status"
                                            )
                                          ? "white"
                                          : "#ced4da66",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem",
                                        width: "100%", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                        display:
                                          userData &&
                                          userData.roles[0].permissions.some(
                                            (item) =>
                                              item.name ===
                                              "Change Event Status"
                                          ),
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                        width: "100%",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided,state) => ({
                                        ...provided,
                                        // color: isDarkMode ? "#ffffff" : "black",
                                        color: state.data.isDisabled ? "#B0B0B0" : isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: state.isDisabled ? "#B0B0B0" : isDarkMode ? "#ffffff" : "black",
                                        backgroundColor:
                                        state.isDisabled
                                            ? isDarkMode
                                              ? "#333333"
                                              : "#f0f0f0":
                                         state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: state.isDisabled ? isDarkMode
                                              ? "#333333"
                                              : "#f0f0f0" :
                                         isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                        // color: state.isDisabled ? "#B0B0B0" : isDarkMode ? "#ffffff" : "black",
                                        //   backgroundColor: state.isDisabled
                                        //     ? isDarkMode
                                        //       ? "#333333"
                                        //       : "#f0f0f0"
                                        //     : provided.backgroundColor, // keep existing background for enabled
                                        //   ":hover": {
                                        //     backgroundColor: state.isDisabled ? undefined : isDarkMode ? "#34DBB4" : "#34DBB4",
                                        //   },
                                        cursor: state.isDisabled ? "not-allowed" : "pointer",
                                      }),
                                    }}
                                  />
                                </>
                              )}
                            />
                          </div>
                        )}
                      </div>
                    </nav>
                  </div>
                  {isMobile && <div className="border-header-mobile"> </div>}
                  <div className="p-2 accordion-section-wraper">
                    <div className="accordion-item first-accord">
                      <h3
                        // className={`mt-2  ${isDarkMode ? "darkthead" : ""}`}
                        className={`accordion-header ${
                          openSection === "section1" ? "active" : ""
                        }   ${isDarkMode ? "darkthead" : ""}`}
                        onClick={() => toggleSection("section1")}
                        style={{ color: isDarkMode ? "#ffffff" : "#495057",}}
                      >
                        {translations.eventHeadings.general[language]}
                        <i
                          className={`accord-arrow-icon bi ${
                            openSection === "section1"
                              ? "bi-chevron-up"
                              : "bi-chevron-down"
                          }`}
                          style={{
                            fontSize: "1rem",
                            marginLeft: "8px",
                            transition: "transform 0.3s",
                          }}
                        ></i>
                      </h3>
                      <div
                        className={`accordion-body quick-creation-form ${
                          openSection === "section1" ? "show" : ""
                        }`}
                        style={{
                          maxHeight: openSection === "section1" && "unset",
                        }}
                      >
                        <div class="row">
                          <div className="col">
                            <div className="row">
                              <label class="form-label">
                                {
                                  translations.quickCreationModal.dealership[
                                    language
                                  ]
                                }
                              </label>
                              <div
                                class={
                                  editMode
                                    ? "col-12"
                                    : userData &&
                                      userData.roles[0].permissions.some(
                                        (item) =>
                                          item.name === "Create Dealership"
                                      )
                                    ? "col-8"
                                    : ""
                                }
                              >
                                <div class="mb-3">
                                  <Field
                                    name="dealership_id"
                                    disabled={isRepresentative}
                                    render={({ field, form }) => (
                                      <Select
                                      isDisabled={isRepresentative}
                                        className="selectpicker"
                                        aria-labelledby="dealership-name-quick"
                                        // isClearable
                                        options={[...options]}
                                        placeholder={
                                          translations["dropdown"].select[
                                            language
                                          ]
                                        }
                                        isSearchable
                                        value={
                                          options.find(
                                            (option) =>
                                              option.value ===
                                              selectedDealership
                                          ) || {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                        }
                                        onChange={(selectedOption) => {
                                          // form.setFieldValue(
                                          //   field.name,
                                          //   selectedOption.value
                                          // );
                                          setSelectedDealership(
                                            selectedOption.value
                                          );
                                          getRep(
                                            selectedOption.value,
                                            values,
                                            setValues
                                          );
                                        }}
                                        maxMenuHeight={"120px"}
                                        styles={{
                                         
                                          input: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black", // Color of the text when typing
                                          }),
                                          control: (provided, state) => ({
                                            ...provided,
                                            // backgroundColor: isDarkMode
                                            //   ? "transparent"
                                            //   : "white",
                                             backgroundColor: isDarkMode
                                            ?  isRepresentative
                                              ? "#ced4da66"
                                              : "transparent"
                                            : isRepresentative
                                              ? "#ced4da66"
                                              : "white",
                                            border: state.isFocused
                                              ? "1px solid #80bdff"
                                              : isDarkMode
                                              ? "1px solid #495057"
                                              : "1px solid #dee2e6", // Adjust the border color for focus
                                            boxShadow: state.isFocused
                                              ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                              : "none", // Bootstrap's box shadow for focus
                                            borderRadius: ".45rem",
                                          }),
                                          valueContainer: (provided) => ({
                                            ...provided,
                                            padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                          }),
                                          indicatorSeparator: (provided) => ({
                                            ...provided,
                                            display: "none", // Hide the indicator separator
                                          }),
                                          dropdownIndicator: (provided) => ({
                                            ...provided,
                                            padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "#868686",
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                            backgroundColor: isDarkMode
                                              ? "#1f2023"
                                              : "white",
                                            margin: "0", // Remove default margin
                                          }),
                                          placeholder: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "#333333", // Specify your desired color for the placeholder
                                            // Additional styles for placeholder
                                          }),
                                          singleValue: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                            backgroundColor: state.isHovered
                                              ? "#80bdff"
                                              : isDarkMode
                                              ? "#1f2023"
                                              : "white",
                                            ":hover": {
                                              backgroundColor: isDarkMode
                                                ? "#34DBB4"
                                                : "#34DBB4",
                                            },
                                          }),
                                        }}
                                      />
                                    )}
                                  />
                                  {/* <Field as="select" class="selectpicker form-select" name="dealer" aria-label="Dealer"
                                id="dealership-name2" data-show-subtext="true" data-live-search="true" fdprocessedid="qo2vc8">
                                <option value="" selected="">Select</option>

                                {dealerships && dealerships.map((dealership) => (
                                  < option key={dealership.id} value={dealership.id}>{dealership.name}</option>
                                ))}
                              </Field> */}
                                  <ErrorMessage
                                    name="dealership_id"
                                    component="div"
                                    className="error text-danger"
                                  />
                                </div>
                              </div>
                              {!editMode &&
                                userData &&
                                userData.roles[0].permissions.some(
                                  (item) => item.name === "Create Dealership"
                                ) && (
                                  <div class="col-4">
                                    <div class="mb-3">
                                      <button
                                        type="button"
                                        class="client-btn btn-success"
                                        id="add-dlr-trigger"
                                        // data-bs-toggle="modal"
                                        // data-bs-target="#AddDealerModal"
                                        data-bs-toggle="modal"
                                        data-bs-target="#myModalCon"
                                        fdprocessedid="wqiuds"
                                      >
                                        <i class="bi bi-plus-circle"></i>{" "}
                                        {
                                          translations["quickCreationModal"]
                                            .addBtn[language]
                                        }
                                      </button>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  translations.quickCreationModal.brand[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="brand_id"
                                disabled={editMode || foundBrand || isRepresentative}
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={brandOptions}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={editMode || foundBrand || isRepresentative}
                                    isSearchable
                                    value={
                                      (brandOptions &&
                                        brandOptions.length > 0 &&
                                        brandOptions.find(
                                          (option) =>
                                            option.value === field.value
                                        )) || {
                                        value: "",
                                        label: foundBrand
                                          ? ""
                                          : translations["dropdown"].select[
                                              language
                                            ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"85px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isDarkMode
                                          ? editMode || foundBrand || isRepresentative
                                            ? "#ced4da66"
                                            : "transparent"
                                          : editMode || foundBrand || isRepresentative
                                          ? "#ced4da66"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                        display:
                                          editMode || foundRep
                                            ? "none"
                                            : "block",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="brand_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                Nom VP
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                name="nom_vp"
                                disabled={true}
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "#ced4da66"
                                    : "#ced4da66",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="nom_vp"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div className="row">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.package[language]}
                              </label>
                              <div
                                className={`${
                                  userData &&
                                  userData.roles[0].permissions.some(
                                    (item) => item.name === "Package Store"
                                  )
                                    ? "col-8"
                                    : "col-12"
                                }`}
                              >
                                <div class="mb-3">
                                  {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                                  <Field
                                    name="package_id"
                                    disabled={isRepresentative}
                                    render={({ field, form }) => (
                                      <Select
                                        className="selectpicker"
                                        aria-labelledby="dealership-name-quick"
                                        // isClearable
                                        options={packages}
                                        placeholder={
                                          translations["dropdown"].select[
                                            language
                                          ]
                                        }
                                        isDisabled={isRepresentative}
                                        isSearchable
                                        value={
                                          (packages &&
                                            packages.length > 0 &&
                                            packages.find(
                                              (option) =>
                                                option.value === selectedPackage
                                            )) || {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                        }
                                        onChange={(selectedOption) => {
                                          form.setFieldValue(
                                            field.name,
                                            selectedOption.value
                                          );
                                          setSelectedPackage(
                                            selectedOption.value
                                          );
                                        }}
                                        maxMenuHeight={"120px"}
                                        styles={{
                                          input: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black", // Color of the text when typing
                                          }),
                                          control: (provided, state) => ({
                                            ...provided,
                                            // backgroundColor: isDarkMode
                                            //   ? "transparent"
                                            //   : "white",
                                             backgroundColor: isDarkMode
                                            ?  isRepresentative
                                              ? "#ced4da66"
                                              : "transparent"
                                            : isRepresentative
                                              ? "#ced4da66"
                                              : "white",
                                            border: state.isFocused
                                              ? "1px solid #80bdff"
                                              : isDarkMode
                                              ? "1px solid #495057"
                                              : "1px solid #dee2e6", // Adjust the border color for focus
                                            boxShadow: state.isFocused
                                              ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                              : "none", // Bootstrap's box shadow for focus
                                            borderRadius: ".45rem",
                                          }),
                                          valueContainer: (provided) => ({
                                            ...provided,
                                            padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                          }),
                                          indicatorSeparator: (provided) => ({
                                            ...provided,
                                            display: "none", // Hide the indicator separator
                                          }),
                                          dropdownIndicator: (provided) => ({
                                            ...provided,
                                            padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "#868686",
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                            backgroundColor: isDarkMode
                                              ? "#1f2023"
                                              : "white",
                                            margin: "0", // Remove default margin
                                          }),
                                          placeholder: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "#333333", // Specify your desired color for the placeholder
                                            // Additional styles for placeholder
                                          }),
                                          singleValue: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                            backgroundColor: state.isHovered
                                              ? "#80bdff"
                                              : isDarkMode
                                              ? "#1f2023"
                                              : "white",
                                            ":hover": {
                                              backgroundColor: isDarkMode
                                                ? "#34DBB4"
                                                : "#34DBB4",
                                            },
                                          }),
                                        }}
                                      />
                                    )}
                                  />
                                  <ErrorMessage
                                    name="package_id"
                                    component="div"
                                    className="error text-danger"
                                  />
                                </div>
                              </div>
                              {userData &&
                                userData.roles[0].permissions.some(
                                  (item) => item.name === "Package Store"
                                ) && (
                                  <div class="col-4">
                                    <div class="mb-3">
                                      <button
                                        type="button"
                                        class="client-btn btn-success"
                                        id="add-dlr-trigger"
                                        data-bs-toggle="modal"
                                        data-bs-target="#packageModal"
                                        fdprocessedid="wqiuds"
                                      >
                                        <i class="bi bi-plus-circle"></i>{" "}
                                        {
                                          translations["quickCreationModal"]
                                            .addBtn[language]
                                        }
                                      </button>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <div class="mb-3">
                                  <label
                                    for="last-sale-date"
                                    class="form-label"
                                  >
                                    {
                                      pageTranslations.privateEventformFields
                                        .startDate[language]
                                    }
                                  </label>
                                  <Field
                                    type="date"
                                    disabled={isRepresentative}
                                    style={{
                                      // backgroundColor: isDarkMode
                                      //   ? "transparent"
                                      //   : "",
                                      backgroundColor: isDarkMode
                                        ? isRepresentative
                                          ? "#ced4da66"
                                          : "transparent"
                                        : isRepresentative
                                          ? "#ced4da66"
                                          : "white",
                                      color: isDarkMode ? "#ffffff" : "#000000",
                                      border: isDarkMode
                                        ? "1px solid #495057"
                                        : "1px solid #dee2e6",
                                    }}
                                    name="start_date"
                                    class={`form-control ${
                                      isDarkMode ? "custom-date" : ""
                                    }`}
                                    onChange={(e) => {
                                      const date = new Date(e.target.value);

                                      setValues({
                                        ...values,
                                        start_date: e.target.value,
                                        week: getWeekOfYear(date),
                                      });
                                    }}
                                    id="last-sale-date"
                                  />
                                  <ErrorMessage
                                    name="start_date"
                                    component="div"
                                    className="error text-danger"
                                  />
                                </div>
                                {false && (
                                  <div class="mb-3">
                                    <Field
                                      name="dealer"
                                      disabled={isRepresentative}
                                      render={({ field, form }) => (
                                        <Select
                                          className="selectpicker"
                                          aria-labelledby="dealership-name-quick"
                                          // isClearable
                                          options={[
                                            {
                                              value: "",
                                              label:
                                                translations["dropdown"].select[
                                                  language
                                                ],
                                            },
                                            ...options,
                                          ]}
                                          placeholder={
                                            translations["dropdown"].select[
                                              language
                                            ]
                                          }
                                          isDisabled={isRepresentative}
                                          isSearchable
                                          value={
                                            options.find(
                                              (option) =>
                                                option.value === field.value
                                            ) || {
                                              value: "",
                                              label:
                                                translations["dropdown"].select[
                                                  language
                                                ],
                                            }
                                          }
                                          onChange={(selectedOption) =>
                                            form.setFieldValue(
                                              field.name,
                                              selectedOption.value
                                            )
                                          }
                                          styles={{
                                            input: (provided) => ({
                                              ...provided,
                                              color: isDarkMode
                                                ? "#ffffff"
                                                : "black", // Color of the text when typing
                                            }),
                                            control: (provided, state) => ({
                                              ...provided,
                                              // backgroundColor: isDarkMode
                                              //   ? "transparent"
                                              //   : "white",
                                               backgroundColor: isDarkMode
                                            ?  isRepresentative
                                              ? "#ced4da66"
                                              : "transparent"
                                            : isRepresentative
                                              ? "#ced4da66"
                                              : "white",
                                              border: state.isFocused
                                                ? "1px solid #80bdff"
                                                : isDarkMode
                                                ? "1px solid #495057"
                                                : "1px solid #dee2e6", // Adjust the border color for focus
                                              boxShadow: state.isFocused
                                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                                : "none", // Bootstrap's box shadow for focus
                                              borderRadius: ".25rem",
                                            }),
                                            valueContainer: (provided) => ({
                                              ...provided,
                                              padding: "0.375rem 0.75rem", // Bootstrap's padding for the value container
                                            }),
                                            indicatorSeparator: (provided) => ({
                                              ...provided,
                                              display: "none", // Hide the indicator separator
                                            }),
                                            dropdownIndicator: (provided) => ({
                                              ...provided,
                                              padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                              color: isDarkMode
                                                ? "#ffffff"
                                                : "#868686",
                                            }),
                                            menu: (provided) => ({
                                              ...provided,
                                              color: isDarkMode
                                                ? "#ffffff"
                                                : "black",
                                              backgroundColor: isDarkMode
                                                ? "#1f2023"
                                                : "white",
                                              margin: "0", // Remove default margin
                                            }),
                                            placeholder: (provided) => ({
                                              ...provided,
                                              color: isDarkMode
                                                ? "#ffffff"
                                                : "#333333", // Specify your desired color for the placeholder
                                              // Additional styles for placeholder
                                            }),
                                            singleValue: (provided) => ({
                                              ...provided,
                                              color: isDarkMode
                                                ? "#ffffff"
                                                : "black",
                                            }),
                                            option: (provided, state) => ({
                                              ...provided,
                                              color: isDarkMode
                                                ? "#ffffff"
                                                : "black",
                                              backgroundColor: state.isHovered
                                                ? "#80bdff"
                                                : isDarkMode
                                                ? "#1f2023"
                                                : "white",
                                              ":hover": {
                                                backgroundColor: isDarkMode
                                                  ? "#34DBB4"
                                                  : "#34DBB4",
                                              },
                                            }),
                                          }}
                                        />
                                      )}
                                    />
                                    {/* <Field as="select" class="selectpicker form-select" name="dealer" aria-label="Dealer"
                                  id="dealership-name2" data-show-subtext="true" data-live-search="true" fdprocessedid="qo2vc8">
                                  <option value="" selected="">Select</option>

                                  {dealerships && dealerships.map((dealership) => (
                                    < option key={dealership.id} value={dealership.id}>{dealership.name}</option>
                                  ))}
                                </Field> */}
                                    <ErrorMessage
                                      name="dealer"
                                      component="div"
                                      className="error text-danger"
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label for="last-sale-date" class="form-label">
                                {
                                  pageTranslations.privateEventformFields
                                    .endDate[language]
                                }
                              </label>
                              <Field
                                type="date"
                                disabled={isRepresentative}
                                style={{
                                  // backgroundColor: isDarkMode
                                  //   ? "transparent"
                                  //   : "",
                                  backgroundColor: isDarkMode
                                    ? isRepresentative
                                      ? "#ced4da66"
                                      : "transparent"
                                    : isRepresentative
                                      ? "#ced4da66"
                                      : "white",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                                name="end_date"
                                class={`form-control ${
                                  isDarkMode ? "custom-date" : ""
                                }`}
                                id="last-sale-date"
                              />
                              <ErrorMessage
                                name="end_date"
                                component="div"
                                className="error text-danger"
                              />
                            </div>{" "}
                          </div>
                        </div>
                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label class="form-label">
                                {
                                  pageTranslations.formFields
                                    .sales_representative[language]
                                }
                              </label>
                              <Field
                                name="sales_rep_id"
                                disabled={
                                  (editMode &&
                                    userData &&
                                    !userData.roles[0].permissions.some(
                                      (item) =>
                                        item.name ===
                                        "Sales Representative Edit"
                                    )) ||
                                  foundRep || isRepresentative
                                }
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    isDisabled={
                                      (editMode &&
                                        userData &&
                                        !userData.roles[0].permissions.some(
                                          (item) =>
                                            item.name ===
                                            "Sales Representative Edit"
                                        )) ||
                                      foundRep || isRepresentative
                                    }
                                    // isClearable
                                    options={repOptions}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isSearchable
                                    value={
                                      (repOptions &&
                                        repOptions.length > 0 &&
                                        repOptions.find(
                                          (option) =>
                                            option.value === field.value
                                        )) || {
                                        value: "",
                                        label: foundRep
                                          ? ""
                                          : translations["dropdown"].select[
                                              language
                                            ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isDarkMode
                                          ? (editMode &&
                                              userData &&
                                              !userData.roles[0].permissions.some(
                                                (item) =>
                                                  item.name ===
                                                  "Sales Representative Edit"
                                              )) ||
                                            foundRep || isRepresentative
                                            ? "#ced4da66"
                                            : "transparent"
                                          : (editMode &&
                                              userData &&
                                              !userData.roles[0].permissions.some(
                                                (item) =>
                                                  item.name ===
                                                  "Sales Representative Edit"
                                              )) ||
                                            foundRep
                                          ? "#ced4da66"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                        display:
                                          (editMode &&
                                            userData &&
                                            !userData.roles[0].permissions.some(
                                              (item) =>
                                                item.name ===
                                                "Sales Representative Edit"
                                            )) ||
                                          foundRep
                                            ? "none"
                                            : "block",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="sales_rep_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.animator[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="animator_id"
                                disabled={isRepresentative}
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={animatorOptions}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={
                                      (userData &&
                                      !userData.roles[0].permissions.some(
                                        (item) =>
                                          item.name === "Animator DropDown"
                                      ))
                                      || isRepresentative
                                    }
                                    isSearchable
                                    value={
                                      (animatorOptions &&
                                        animatorOptions.length > 0 &&
                                        animatorOptions.find(
                                          (option) =>
                                            option.value?.toString() ===
                                            field.value?.toString()
                                        )) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        // backgroundColor: isDarkMode
                                        //   ? (userData &&
                                        //     userData.roles[0].permissions.some(
                                        //       (item) =>
                                        //         item.name ===
                                        //         "Animator DropDown"
                                        //     ))
                                        //     ? "transparent"
                                        //     : "#ced4da66"
                                        //   : (userData &&
                                        //     userData.roles[0].permissions.some(
                                        //       (item) =>
                                        //         item.name ===
                                        //         "Animator DropDown"
                                        //     ))
                                        //   ? "white"
                                        //   : "#ced4da66",
                                        backgroundColor: isRepresentative
                                          ? "#ced4da66"
                                          : isDarkMode
                                            ? userData &&
                                              userData.roles[0].permissions.some(
                                                (item) => item.name === "Animator DropDown"
                                              )
                                              ? "transparent"
                                              : "#ced4da66"
                                            : userData &&
                                              userData.roles[0].permissions.some(
                                                (item) => item.name === "Animator DropDown"
                                              )
                                              ? "white"
                                              : "#ced4da66",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                        display:
                                          userData &&
                                          userData.roles[0].permissions.some(
                                            (item) =>
                                              item.name === "Animator DropDown"
                                          )
                                            ? "block"
                                            : "none",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="animator_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label class="form-label">
                                {
                                  pageTranslations.formFields.projectManager[
                                    language
                                  ]
                                }
                              </label>
                              <Field
                                name="project_manager_id"
                                disabled={isRepresentative}
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={managerOptions}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      (managerOptions &&
                                        managerOptions.length > 0 &&
                                        managerOptions.find(
                                          (option) =>
                                            option.value === field.value
                                        )) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        // backgroundColor: isDarkMode
                                        //   ? "transparent"
                                        //   : "white",
                                         backgroundColor: isDarkMode
                                            ?  isRepresentative
                                              ? "#ced4da66"
                                              : "transparent"
                                            : isRepresentative
                                              ? "#ced4da66"
                                              : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />

                              <ErrorMessage
                                name="project_manager_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          {false && (
                            <>
                              <div class="col-4">
                                <div class="mb-3">
                                  <label
                                    for="annual-sales-count"
                                    class="form-label"
                                  >
                                    {
                                      translations.usersPage.createUser.status[
                                        language
                                      ]
                                    }
                                  </label>
                                  {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                                  <Field
                                    name="status"
                                    disabled={isRepresentative}
                                    render={({ field, form }) => (
                                      <Select
                                        className="selectpicker"
                                        aria-labelledby="dealership-name-quick"
                                        // isClearable
                                        // options={statusOptions}
                                        options={statusOptions.map((opt) => ({
                                      ...opt,
                                      isDisabled: opt.value.toLocaleLowerCase() === "pending" &&  !isAdminUser
                                    }))}
                                        placeholder={
                                          translations["dropdown"].select[
                                            language
                                          ]
                                        }
                                        isDisabled={
                                          userData &&
                                          !userData.roles[0].permissions.some(
                                            (item) =>
                                              item.name ===
                                              "Change Event Status"
                                          ) || isRepresentative
                                        }
                                        isSearchable={false}
                                        value={
                                          (statusOptions &&
                                            statusOptions.length > 0 &&
                                            statusOptions.find(
                                              (option) =>
                                                option.value === field.value
                                            )) || {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                        }
                                        onChange={(selectedOption) => {
                                          form.setFieldValue(
                                            field.name,
                                            selectedOption.value
                                          );
                                        }}
                                        maxMenuHeight={"120px"}
                                        styles={{
                                          input: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black", // Color of the text when typing
                                          }),
                                          control: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: isRepresentative ?
                                              "#ced4da66"
                                            :isDarkMode
                                              ? userData &&
                                                userData.roles[0].permissions.some(
                                                  (item) =>
                                                    item.name ===
                                                    "Change Event Status"
                                                )
                                                ? "transparent"
                                                : "#ced4da66"
                                              : userData &&
                                                userData.roles[0].permissions.some(
                                                  (item) =>
                                                    item.name ===
                                                    "Change Event Status"
                                                )
                                              ? "white"
                                              : "#ced4da66",
                                            border: state.isFocused
                                              ? "1px solid #80bdff"
                                              : isDarkMode
                                              ? "1px solid #495057"
                                              : "1px solid #dee2e6", // Adjust the border color for focus
                                            boxShadow: state.isFocused
                                              ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                              : "none", // Bootstrap's box shadow for focus
                                            borderRadius: ".45rem",
                                          }),
                                          valueContainer: (provided) => ({
                                            ...provided,
                                            padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                          }),
                                          indicatorSeparator: (provided) => ({
                                            ...provided,
                                            display: "none", // Hide the indicator separator
                                          }),
                                          dropdownIndicator: (provided) => ({
                                            ...provided,
                                            padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "#868686",
                                            display:
                                              userData &&
                                              userData.roles[0].permissions.some(
                                                (item) =>
                                                  item.name ===
                                                  "Change Event Status"
                                              )
                                                ? "block"
                                                : "none",
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                            backgroundColor: isDarkMode
                                              ? "#1f2023"
                                              : "white",
                                            margin: "0", // Remove default margin
                                          }),
                                          placeholder: (provided) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "#333333", // Specify your desired color for the placeholder
                                            // Additional styles for placeholder
                                          }),
                                          singleValue: (provided,state) => ({
                                            ...provided,
                                            // color: isDarkMode
                                            //   ? "#ffffff"
                                            //   : "black",
                                            color: state.data.isDisabled ? "#B0B0B0" : isDarkMode ? "#ffffff" : "black",
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            color: isDarkMode
                                              ? "#ffffff"
                                              : "black",
                                            // backgroundColor: state.isHovered
                                            //   ? "#80bdff"
                                            //   : isDarkMode
                                            //   ? "#1f2023"
                                            //   : "white",
                                            ":hover": {
                                              backgroundColor: isDarkMode
                                                ? "#34DBB4"
                                                : "#34DBB4",
                                            },
                                            cursor: state.isDisabled ? "not-allowed" : "pointer",
                                          }),
                                        }}
                                      />
                                    )}
                                  />
                                  <ErrorMessage
                                    name="status"
                                    component="div"
                                    className="error text-danger"
                                  />
                                </div>
                              </div>

                              <div class="col-4">
                                <div class="mb-3">
                                  <label
                                    for="annual-sales-count"
                                    class="form-label"
                                  >
                                    {
                                      translations.EventsPortal
                                        .eventsTableHeader.week[language]
                                    }
                                  </label>
                                  {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                                  <Field
                                    type="text"
                                    name="week"
                                    disabled={true}
                                    class="form-control"
                                    id="event-comm"
                                    style={{
                                      backgroundColor: isDarkMode
                                        ? "#ced4da66"
                                        : "",
                                      color: isDarkMode ? "#ffffff" : "#000000",
                                      border: isDarkMode
                                        ? "1px solid #495057"
                                        : "1px solid #dee2e6",
                                    }}
                                  ></Field>
                                  <ErrorMessage
                                    name="week"
                                    component="div"
                                    className="error text-danger"
                                  />
                                </div>
                              </div>
                            </>
                          )}

                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.confirmationAgent[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="confirmation_agent_id"
                                disabled={isRepresentative}
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={agentOptions}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      (agentOptions &&
                                        agentOptions.length > 0 &&
                                        agentOptions.find(
                                          (option) =>
                                            option.value === field.value
                                        )) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="confirmation_agent_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.noShowAgent[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="no_show_agent_id"
                                disabled={isRepresentative}
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={agentOptions}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      (agentOptions &&
                                        agentOptions.length > 0 &&
                                        agentOptions.find(
                                          (option) =>
                                            option.value === field.value
                                        )) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="no_show_agent_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col-4">
                            <div className="mb-3">
                              <label
                                htmlFor="call_campaign"
                                className="form-label"
                              >
                                {
                                  pageTranslations.formFields.call_campaign[
                                    language
                                  ]
                                }
                              </label>
                              <Field
                                name="call_campaign"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="booking-type"
                                    options={[
                                      {
                                        value: "regular",
                                        label:
                                          language === "fr"
                                            ? "Régulier"
                                            : "Regular",
                                      },
                                      {
                                        value: "early",
                                        label:
                                          language === "fr"
                                            ? "2 semaines en avance"
                                            : "2 Weeks Early",
                                      },
                                    ]}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable={false} // no need to search for 2 options
                                    value={
                                      field.value
                                        ? [
                                            {
                                              value: "regular",
                                              label:
                                                language === "fr"
                                                  ? "Régulier"
                                                  : "Regular",
                                            },
                                            {
                                              value: "early",
                                              label:
                                                language === "fr"
                                                  ? "2 semaines en avance"
                                                  : "2 Weeks Early",
                                            },
                                          ].find(
                                            (option) =>
                                              option.value === field.value
                                          )
                                        : {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none",
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem",
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none",
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem",
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333",
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="call_campaign"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                           <div class="col-4">
                            <div className="mb-3">
                              <label
                                htmlFor="call_centre"
                                className="form-label"
                              >
                                {
                                  pageTranslations.formFields.call_centre[
                                    language
                                  ]
                                }
                              </label>
                              <Field
                                name="call_centre"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="booking-type"
                                    options={[
                                      {
                                        value: "internal",
                                        label:
                                          language === "fr"
                                            ? "Internes"
                                            : "Internal",
                                      },
                                      {
                                        value: "external",
                                        label:
                                          language === "fr"
                                            ? "Externes"
                                            : "External",
                                      },
                                      {
                                        value: "internal-external",
                                        label:
                                          language === "fr"
                                            ? "Interne-Externe"
                                            : "Internal-External",
                                      },
                                    ]}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable={false} // no need to search for 2 options
                                    value={
                                      field.value
                                        ? [
                                            {
                                              value: "internal",
                                              label:
                                                language === "fr"
                                                  ? "Internes"
                                                  : "Internal",
                                            },
                                            {
                                              value: "external",
                                              label:
                                                language === "fr"
                                                  ? "Externes"
                                                  : "External",
                                            },
                                          ].find(
                                            (option) =>
                                              option.value === field.value
                                          )
                                        : {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none",
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem",
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none",
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem",
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333",
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="call_centre"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields
                                    .promoAndRequestSection.comments[language]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                as="textarea"
                                type="text"
                                name="comments"
                                class="form-control"
                                id="event-comm"
                                disabled={isRepresentative}
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="comments"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h3
                        // className={`mt-4 ${isDarkMode ? "darkthead" : ""}`}
                        className={`accordion-header ${
                          openSection === "section2" ? "active" : ""
                        }   ${isDarkMode ? "darkthead" : ""}`}
                        onClick={() => toggleSection("section2")}
                      >
                        {translations.eventHeadings.dialerConnection[language]}
                        <i
                          className={`accord-arrow-icon bi ${
                            openSection === "section2"
                              ? "bi-chevron-up"
                              : "bi-chevron-down"
                          }`}
                          style={{
                            fontSize: "1rem",
                            marginLeft: "8px",
                            transition: "transform 0.3s",
                          }}
                        ></i>
                      </h3>
                      <div
                        className={`accordion-body quick-creation-form ${
                          openSection === "section2" ? "show" : ""
                        }`}
                        style={{
                          maxHeight: openSection === "section2" && "unset",
                        }}
                      >
                        <div className="row">
                          <div className="col-4">
                            <div className="mb-3">
                              <label className="form-label">
                                {
                                  translations.createProspective.listIds[
                                    language
                                  ]
                                }
                              </label>
                              <Field
                                name="list_id"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={listIds}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      listIds && listIds.length > 0
                                        ? listIds.find(
                                            (option) =>
                                              option?.value?.toString() ===
                                              field?.value?.toString()
                                          ) || {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                        : eventData
                                        ? [
                                            {
                                              label: eventData?.list_name,
                                              value: eventData?.list_id,
                                            },
                                          ]
                                        : {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                    }
                                    onChange={(selectedOption) =>
                                      setValues({
                                        ...values,
                                        list_id: selectedOption.value,
                                        list_name: selectedOption.label,
                                      })
                                    }
                                    onFocus={() => {
                                      if (listIds && listIds.length === 0) {
                                        getListIds();
                                      }
                                    }}
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                        display: "block",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="list_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="mb-3">
                              <label className="form-label">
                                {
                                  translations.createProspective.configId[
                                    language
                                  ]
                                }
                              </label>
                              <Field
                                name="config_id"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={configIds}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      configIds && configIds.length > 0
                                        ? configIds.find(
                                            (option) =>
                                              option?.value?.toString() ===
                                              field?.value?.toString()
                                          ) || {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                        : eventData
                                        ? [
                                            {
                                              label: eventData?.config_name,
                                              value: eventData?.config_id,
                                            },
                                          ]
                                        : {
                                            value: "",
                                            label:
                                              translations["dropdown"].select[
                                                language
                                              ],
                                          }
                                    }
                                    onChange={(selectedOption) =>
                                      setValues({
                                        ...values,
                                        config_id: selectedOption.value,
                                        config_name: selectedOption.label,
                                      })
                                    }
                                    onFocus={() => {
                                      if (listIds && listIds.length === 0) {
                                        getListIds();
                                      }
                                    }}
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                        display: "block",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="config_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h3
                        // className={`mt-4 ${isDarkMode ? "darkthead" : ""}`}
                        className={`accordion-header ${
                          openSection === "section3" ? "active" : ""
                        }   ${isDarkMode ? "darkthead" : ""}`}
                        onClick={() => toggleSection("section3")}
                      >
                        {translations.eventHeadings.components[language]}
                        <i
                          className={`accord-arrow-icon bi ${
                            openSection === "section3"
                              ? "bi-chevron-up"
                              : "bi-chevron-down"
                          }`}
                          style={{
                            fontSize: "1rem",
                            marginLeft: "8px",
                            transition: "transform 0.3s",
                          }}
                        ></i>
                      </h3>
                      <div
                        className={`accordion-body quick-creation-form ${
                          openSection === "section3" ? "show" : ""
                        }`}
                        style={{
                          maxHeight: openSection === "section3" && "unset",
                        }}
                      >
                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.carton[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="carton"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={commonDropdown}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      commonDropdown.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="carton"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.mailing[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                name="mailing"
                                class="form-control"
                                disabled={isRepresentative}
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="mailing"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  translations.usersPage.createUser
                                    .statusOptions.active[language]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                name="clients"
                                disabled={isRepresentative}
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="clients"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.inactive[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                disabled={isRepresentative}
                                name="inactive"
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="inactive"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.conquestSection
                                    .title[language]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                name="conquest"
                                disabled={isRepresentative}
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="conquest"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.massif[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                name="massif"
                                disabled={isRepresentative}
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="massif"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.web[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="web"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={commonDropdown}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      commonDropdown.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="web"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.banner[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="banner"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={commonDropdown}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      commonDropdown.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="banner"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.newsletter[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="news_letter"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={commonDropdown}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      commonDropdown.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="news_letter"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.facebook[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="facebook"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={commonDropdown}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      commonDropdown.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="facebook"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.adwords[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="ad_words"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={commonDropdown}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      commonDropdown.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="ad_words"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {"SMS"}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="sms"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={commonDropdown}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      commonDropdown.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="sms"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.fidgi_contest[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                name="fidgi_contest"
                                render={({ field, form }) => (
                                  <Select
                                    className="selectpicker"
                                    aria-labelledby="dealership-name-quick"
                                    // isClearable
                                    options={fidgiContestOptions}
                                    placeholder={
                                      translations["dropdown"].select[language]
                                    }
                                    isDisabled={isRepresentative}
                                    isSearchable
                                    value={
                                      fidgiContestOptions.find(
                                        (option) => option.value === field.value
                                      ) || {
                                        value: "",
                                        label:
                                          translations["dropdown"].select[
                                            language
                                          ],
                                      }
                                    }
                                    onChange={(selectedOption) =>
                                      form.setFieldValue(
                                        field.name,
                                        selectedOption.value
                                      )
                                    }
                                    maxMenuHeight={"120px"}
                                    styles={{
                                      input: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                      }),
                                      control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: isRepresentative ? "#ced4da66" : isDarkMode
                                          ? "transparent"
                                          : "white",
                                        border: state.isFocused
                                          ? "1px solid #80bdff"
                                          : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none", // Bootstrap's box shadow for focus
                                        borderRadius: ".45rem",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                      }),
                                      indicatorSeparator: (provided) => ({
                                        ...provided,
                                        display: "none", // Hide the indicator separator
                                      }),
                                      dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#868686",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        margin: "0", // Remove default margin
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode
                                          ? "#ffffff"
                                          : "#333333", // Specify your desired color for the placeholder
                                        // Additional styles for placeholder
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        color: isDarkMode ? "#ffffff" : "black",
                                        backgroundColor: state.isHovered
                                          ? "#80bdff"
                                          : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                        ":hover": {
                                          backgroundColor: isDarkMode
                                            ? "#34DBB4"
                                            : "#34DBB4",
                                        },
                                      }),
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                name="fidgi_contest"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item ">
                      <h3
                        // className={`mt-4 ${isDarkMode ? "darkthead" : ""}`}
                        className={`accordion-header ${
                          openSection === "section4" ? "active" : ""
                        } ${isDarkMode ? "darkthead" : ""}`}
                        onClick={() => toggleSection("section4")}
                      >
                        {translations.eventHeadings.accounting[language]}
                        <i
                          className={`accord-arrow-icon bi ${
                            openSection === "section4"
                              ? "bi-chevron-up"
                              : "bi-chevron-down"
                          }`}
                          style={{
                            fontSize: "1rem",
                            marginLeft: "8px",
                            transition: "transform 0.3s",
                          }}
                        ></i>
                      </h3>
                      <div
                        className={`accordion-body quick-creation-form ${
                          openSection === "section4" ? "show" : ""
                        }`}
                        style={{
                          maxHeight: openSection === "section4" && "unset",
                        }}
                      >
                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.amount[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                name="amount"
                                validate={validateAmount}
                                inputMode="decimal"
                                placeholder={
                                  pageTranslations.formFields.amountPlaceholder[
                                    language
                                  ]
                                }
                                disabled={isRepresentative}
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="amount"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {pageTranslations.formFields.invoice[language]}
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                name="invoice"
                                disabled={isRepresentative}
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="invoice"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.amountAnimator[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                disabled={isRepresentative}
                                name="amount_animator"
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="amount_animator"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.invoiceAnimator[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                disabled={isRepresentative}
                                name="invoice_animator"
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="invoice_animator"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.commissionPaid[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                disabled={isRepresentative}
                                name="commission_paid"
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="commission_paid"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="mb-3">
                              <label
                                for="annual-sales-count"
                                class="form-label"
                              >
                                {
                                  pageTranslations.formFields.instructions[
                                    language
                                  ]
                                }
                              </label>
                              {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                              <Field
                                type="text"
                                disabled={isRepresentative}
                                name="instructions"
                                class="form-control"
                                id="event-comm"
                                style={{
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                  border: isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6",
                                }}
                              ></Field>
                              <ErrorMessage
                                name="instructions"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div class="col">
                              <div class="mb-3">
                                <label
                                  for="annual-sales-count"
                                  class="form-label"
                                >
                                  {
                                    translations.viewBillingPage.mailingAmount[
                                      language
                                    ]
                                  }
                                </label>
                                {/* <Field type="text" name="digital" class="form-control" id="annual-sales-count" fdprocessedid="g00vec" /> */}
                                <Field
                                  type="text"
                                  disabled={isRepresentative}
                                  name="mailing_amount"
                                  class="form-control"
                                  id="event-comm"
                                  style={{
                                    backgroundColor: isDarkMode
                                      ? "transparent"
                                      : "",
                                    color: isDarkMode ? "#ffffff" : "#000000",
                                    border: isDarkMode
                                      ? "1px solid #495057"
                                      : "1px solid #dee2e6",
                                  }}
                                ></Field>
                                <ErrorMessage
                                  name="mailing_amount"
                                  component="div"
                                  className="error text-danger"
                                />
                              </div>
                            </div>
                            <div className="col"></div>
                            <div className="col"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {editMode &&
                      userData &&
                      userData.roles[0].permissions.some(
                        (item) => item.name === "Parent Form"
                      ) && (
                        <div className="accordion-item last-accord">
                          <div
                            style={{ marginBottom: "10px !important" }}
                            class="row "
                          >
                            <div
                              style={{ margin: "10px 0" }}
                              className="form-wraper-mobile"
                              id=""
                            >
                              <div class="card card-body docsection form-wraper-mobile-header-container">
                                {/* <h3
                                className={`${isDarkMode ? "darkthead" : ""}`}
                              >
                                {translations.topAndsidebar.forms[language]}
                              </h3> */}
                                <h3
                                  className={`accordion-header ${
                                    openSection === "section5" ? "active" : ""
                                  } ${isDarkMode ? "darkthead" : ""}`}
                                  onClick={() => toggleSection("section5")}
                                >
                                  {translations.topAndsidebar.forms[language]}
                                  <i
                                    className={`accord-arrow-icon bi ${
                                      openSection === "section5"
                                        ? "bi-chevron-up"
                                        : "bi-chevron-down"
                                    }`}
                                    style={{
                                      fontSize: "1rem",
                                      marginLeft: "8px",
                                      transition: "transform 0.3s",
                                    }}
                                  ></i>
                                </h3>
                                <div
                                  className={`accordion-body quick-creation-form ${
                                    openSection === "section5" ? "show" : ""
                                  }`}
                                  style={{
                                    maxHeight:
                                      openSection === "section5" && "unset",
                                  }}
                                >
                                  <table
                                    class={`table table-hover text-center align-middle table-sm `}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className={`${
                                            isDarkMode ? "darkthead" : ""
                                          }`}
                                        >
                                          #
                                        </th>
                                        <th
                                          scope="col"
                                          className={`${
                                            isDarkMode ? "darkthead" : ""
                                          }`}
                                        >
                                          {" "}
                                          {
                                            pageTranslations.formFields
                                              .documentSection.createdOn[
                                              language
                                            ]
                                          }{" "}
                                        </th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody id="clientEntryTable" class="">
                                      {parentForms &&
                                        parentForms.length > 0 &&
                                        parentForms.map((form) => (
                                          <tr class="result-box">
                                            <td class="entryID" scope="row">
                                              {form.id}
                                            </td>
                                            <td class="submitedON">
                                              {form?.created_at?.split("T")[0]}
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                class="admin-btn btn-primary edit-client-form-button"
                                                data-customer-id="29"
                                                data-main-id="920"
                                                onClick={() => {
                                                  setDisplayComponent(
                                                    "edit-form"
                                                  );
                                                  window.history.pushState(
                                                    {
                                                      id: "gallery",
                                                      randomData:
                                                        window.Math.random(),
                                                    },
                                                    "title",
                                                    "/event-portal?page=edit-form&event_id=" +
                                                      eventId +
                                                      "&form_id=" +
                                                      form.id
                                                  );
                                                }}
                                              >
                                                <i class="bi bi-send"></i>{" "}
                                                {
                                                  translations.commonWords.view[
                                                    language
                                                  ]
                                                }{" "}
                                              </button>
                                            </td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="border-top-mobile"> </div>
                  {userData &&
                    userData.roles[0].permissions.some(
                      (item) => item.name === "Private Event Show"
                    ) && (
                      <div class="footersec">
                        <div class="row">
                          {isMobile ? (
                            <>
                              <div
                                class="d-flex footersec-mobile"
                                style={{ padding: 7 }}
                              >
                                <button
                                  type="submit"
                                  class="client-btn btn-success mx-2"
                                  id="add-customer-button"
                                >
                                  <i class="bi bi-save"></i>{" "}
                                  {
                                    translations["commonFields"].submitBtn[
                                      language
                                    ]
                                  }
                                </button>
                                <div
                                  className="mx-2"
                                  style={{ display: "flex", gap: "15px" }}
                                >
                                  <button
                                    style={{
                                      width: !editMode ? "100%" : "40%",
                                    }}
                                    type="button"
                                    class="btn btn-danger"
                                    onClick={
                                      () =>
                                        // window.history.pushState({ prevState: 'prev' }, 'title', '/event-portal?page=events')
                                        window.history.back()
                                      // setDisplayComponent('events')
                                    }
                                    id="add-customer-button"
                                  >
                                    <i class="bi bi-save"></i>{" "}
                                    {
                                      translations["commonFields"].returnBtn[
                                        language
                                      ]
                                    }
                                  </button>
                                  {editMode && (
                                    <button
                                      type="button"
                                      style={{ width: "60%" }}
                                      className="admin-btn btn btn-primary "
                                      // disabled={loading}
                                      onClick={() => {
                                        // createEvent();

                                        if (eventData && eventData.copy === "0")
                                          checkParent(eventId);
                                        else {
                                          setDisplayComponent("create-event");

                                          window.history.pushState(
                                            {
                                              id: "gallery",
                                              randomData: window.Math.random(),
                                            },
                                            "title",
                                            "/event-portal?page=create-event&parent_id=" +
                                              eventId +
                                              "&event-navigate=true"
                                          );
                                        }
                                      }}
                                    >
                                      <i class="bi bi-file-earmark-text"></i>{" "}
                                      {
                                        translations["commonFields"].createBtn[
                                          language
                                        ]
                                      }
                                    </button>
                                  )}
                                </div>
                                {renderDeleteEventControls()}
                              </div>
                            </>
                          ) : (
                            <div class="col-sm" style={{ padding: 7 }}>
                              {
                                role !==
                                "Representative" &&

                                <button
                                type="submit"
                                class="client-btn btn-success mx-2"
                                id="add-customer-button"
                              >
                                <i class="bi bi-save"></i>{" "}
                                {
                                  translations["commonFields"].submitBtn[
                                    language
                                  ]
                                }
                              </button>
                              }
                              
                              <button
                                type="button"
                                class="btn btn-danger"
                                onClick={
                                  () =>
                                    // window.history.pushState({ prevState: 'prev' }, 'title', '/event-portal?page=events')
                                    window.history.back()
                                  // setDisplayComponent('events')
                                }
                                id="add-customer-button"
                              >
                                <i class="bi bi-save"></i>{" "}
                                {
                                  translations["commonFields"].returnBtn[
                                    language
                                  ]
                                }
                              </button>
                              {editMode && role !==
                                "Representative" && (
                                <button
                                  type="button"
                                  className="admin-btn btn btn-primary mx-2"
                                  // disabled={loading}
                                  onClick={() => {
                                    // createEvent();

                                    if (eventData && eventData.copy === "0")
                                      checkParent(eventId);
                                    else {
                                      setDisplayComponent("create-event");

                                      window.history.pushState(
                                        {
                                          id: "gallery",
                                          randomData: window.Math.random(),
                                        },
                                        "title",
                                        "/event-portal?page=create-event&parent_id=" +
                                          eventId +
                                          "&event-navigate=true"
                                      );
                                    }
                                  }}
                                >
                                  <i class="bi bi-file-earmark-text"></i>{" "}
                                  {
                                    translations["commonFields"].createBtn[
                                      language
                                    ]
                                  }
                                </button>
                              )}
                              {renderDeleteEventControls()}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CreatePrivateEvent;
